module.exports = __webpack_public_path__ + "img/WizardRiches_DG.fd1cd490.jpg";